import { memo } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';

interface QueueNodeData {
  label: string;
  description?: string;
  queueType?: 'redis' | 'sqs' | 'rabbitmq' | 'kafka';
}

export const QueueNode = memo(function QueueNode({
  data,
  selected,
}: NodeProps) {
  const nodeData = data as unknown as QueueNodeData;

  return (
    <div
      className={`px-4 py-3 rounded-lg border-2 bg-orange-50 min-w-[150px] ${
        selected ? 'border-primary shadow-lg' : 'border-orange-300'
      }`}
    >
      <Handle type="target" position={Position.Top} className="!bg-orange-500" />

      <div className="flex items-center gap-2">
        <span className="text-xl">📨</span>
        <div>
          <div className="font-semibold text-sm">{nodeData.label}</div>
          {nodeData.queueType && (
            <div className="text-xs text-muted-foreground">
              {nodeData.queueType}
            </div>
          )}
          {nodeData.description && (
            <div className="text-xs text-muted-foreground mt-1">
              {nodeData.description}
            </div>
          )}
        </div>
      </div>

      <Handle type="source" position={Position.Bottom} className="!bg-orange-500" />
    </div>
  );
});
